module Shared.Validations.Email

open System
open Illy.SafeStack.SharedValidations
open Illy.SafeStack.Validation
open Illy.SafeStack.ROP
open Illy.SafeStack.CompositionalValidation

let [<Literal>] EMAIL_REGEX = @"^[^.@' ']((?<!\.\.)[^@' '])*@[^@.' ']+\.((?<!\.\.)[^@' '])*[^.@' ']$"

type EmailValidations = 
    | StringValidations of StringValidations
    | MustBeValid
    | CannotContainApostrophes

module EmailValidations = 
    let toString = 
        function 
        | EmailValidations.StringValidations v -> v.toString()
        | EmailValidations.MustBeValid -> "Must be valid."
        | EmailValidations.CannotContainApostrophes -> "Email address cannot contain apostrophes."

let validateEmail email = 
    validate {
        return! (validateString 250 true >-> EmailValidations.StringValidations) email
        return! !!(error EmailValidations.MustBeValid) 
            >>= passIfNone email 
            >>= conditional pass (fun (_, str) -> System.Text.RegularExpressions.Regex.IsMatch(str, EMAIL_REGEX))
            |> firstResult
        return! !!(error EmailValidations.CannotContainApostrophes) 
            >>= passIfNone email 
            >>= conditional pass (fun (_, str) -> String.IsNullOrWhiteSpace str || (str.Contains("'") |> not))
            |> firstResult
    }